import React from 'react';
import { Layers } from 'lucide-react';

interface Props {
  active: boolean;
  open: boolean;
  label: string;
  onClick: () => void;
}

export default function EnstruCategoryButton({ active, open, label, onClick }: Props) {
  return (
    <button
      type="button"
      aria-haspopup="dialog"
      aria-expanded={open}
      onClick={onClick}
      title={label}
      className={`procurement-focus inline-flex min-h-[44px] max-w-full items-center justify-center gap-2 rounded-lg border px-4 py-2.5 text-sm font-semibold transition-colors sm:max-w-[280px] ${
        active
          ? 'border-goszakup-300 bg-goszakup-50 text-goszakup-800 hover:border-goszakup-400 hover:bg-goszakup-100'
          : 'border-slate-200 bg-white text-goszakup-700 hover:border-goszakup-300 hover:bg-goszakup-50'
      }`}
    >
      <Layers className="w-4 h-4 shrink-0" />
      <span className="truncate">{label}</span>
    </button>
  );
}
